<template>
  <div class="navbarComponent">
    <div class="container-sm">
      <div class="inside">
        <div class="case-status">
          <el-row type="flex" :align="middle" justify="end" style="width: 100%">
            <el-col
              :sm="4"
              v-if="hasPermission('cases', 'edit_new') && !isBillingUser"            >
              <div class="editCase">
                <el-tooltip
                  :content="isInternalOrderEditDisabled(caseInfo) ? 'Editing is disabled for internal orders for current user type' : ''"
                  :disabled="!isInternalOrderEditDisabled(caseInfo)"
                  placement="top"
                >
                  <button class="editButton btn" @click="goToEditForm" :disabled="isInternalOrderEditDisabled(caseInfo)">
                    <span class="pr-5"> EDIT </span>
                  </button>
                </el-tooltip>
              </div>
            </el-col>
            <el-col :sm="20">
              <ul class="justify-content-end">
                <li>
                  <div v-if="caseInfo && caseInfo.is_amendement">
                    <el-alert
                      title="Case Details Amended"
                      type="primary"
                      :description="description"
                      :closable="false"
                    />
                  </div>
                </li>
                <li>
                  <h3 class="name">Case Status</h3>
                </li>
                <li v-if="caseInfo && caseInfo.status">
                  <div class="column-status">
                    <el-tag :type="getStatusType(caseInfo.status)">
                      {{
                          caseInfo.status === "COMPLETE"
                          ? "FINALIZED"
                          : caseInfo.status === "TEST_REPORTS"
                          ? "PROCESSING"
                          : caseInfo.status === "ARCHIVED"
                          ? "ARCHIVED"
                          : caseInfo.status === "PENDING"
                          ? "PENDING"
                          : caseInfo.status === "REJECTED"
                          ? "REJECTED"
                          : "ACTIVE"
                      }}
                    </el-tag>
                  </div>
                </li>
                <li v-if="hasPermission('cases', 'create')">
                  <el-button class="pr-5" @click="viewCaseAudit">
                    Audit
                  </el-button>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
  <section
    v-loading="loading"
    class="new-case-view case-creation"
    id="single-case-view"
  >
     <div
      class="order-status-reason"
      v-if="this.caseInfo && this.caseInfo.reasons && this.caseInfo.notes"
    >
      <div class="container-sm">
        <div class="bg-white">
          <ul>
            <li>
              <h4 class="reason-heading">Reasons :</h4>
            </li>
            <li v-for="(reason, index) in this.caseInfo.reasons" :key="index">
              <p>{{ reason }}</p>
            </li>
          </ul>
          <ul>
            <li>
              <h4 class="reason-heading">Notes :</h4>
            </li>
            <li>
              <p>{{ caseInfo.notes }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="case-view-body">
      <div class="container-sm">
        <section id="view-case-screen">
          <PatientInformation></PatientInformation>
          <span class="case-creation__divider"></span>
          <CaseInformation></CaseInformation>
          <span class="case-creation__divider"></span>
          <div v-if="!isBillingUser && isCaseCompleted">
            <CPTCodes></CPTCodes>
          </div>
          <div v-if="!isBillingUser && isCaseCompleted">
            <BillingNotes></BillingNotes>
          </div>
          <div v-if="hasPermission('billing', 'view') && isCaseCompleted">
            <BillingCategory></BillingCategory>
          </div>
          <span class="case-creation__divider" v-if="!isBillingUser"></span>
          <div v-if="isCaseHavingAdditionalNotes">
            <AdditionalNotes></AdditionalNotes>
          </div>
          <div class="case-creation__card">
          <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-case-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Order Codes</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <el-row :gutter="15">
              <el-col
                :xl="3"
                :lg="4"
                :md="8"
                :sm="12"
                :xs="12"
              >
                <div class="input-value view-cases">
                  <p
                    class="value"
                    style="
                      background: #bf1b39;
                      width: 180px;
                      height: 18px;
                      border-radius: 10px;
                      padding-left: 14px;
                      color: white;
                    "
                  >
                    <span v-if="getCaseInformation && getCaseInformation.testgo_order_codes">
                      {{ getCaseInformation.testgo_order_codes.join(', ') }}
                    </span>
                  </p>
                </div>
              </el-col>
              </el-row>
          </div>
          </div>
          <span class="case-creation__divider"></span>
          <Medication></Medication>
          <span class="case-creation__divider" v-if="hasBillingType"></span>
          <div v-if="hasBillingType">
            <BillingInformation></BillingInformation>
          </div>
          <span class="case-creation__divider"></span>
          <div>
            <div>
              <TestAttachments></TestAttachments>
            </div>
          </div>
          <span class="case-creation__divider"></span>
          <TestReport :displayUploading="true"></TestReport>
          <span class="case-creation__divider"></span>
        </section>
      </div>
    </div>
    <AuditLogs
      v-if="AuditLogsPopup"
      v-on:close="AuditLogsPopup = false"
      :caseId="caseId"
    ></AuditLogs>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
const BillingNotes = defineAsyncComponent(() =>
  import("@/components/cases/BillingNotes")
);
const BillingCategory = defineAsyncComponent(() =>
  import("@/components/cases/BillingCategory")
);
const CPTCodes = defineAsyncComponent(() =>
  import("@/components/cases/CPTCodes")
);
const PatientInformation = defineAsyncComponent(() =>
  import("@/components/cases/PatientInformation")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/cases/CaseInformation")
);
const Medication = defineAsyncComponent(() =>
  import("@/components/cases/MedicationView")
);
const TestAttachments = defineAsyncComponent(() =>
  import("@/components/cases/TestAttachments")
);
const TestReport = defineAsyncComponent(() =>
  import("@/components/cases/ViewTestReport")
);
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
import AuditLogs from "@/components/cases/AllLogs";
const AdditionalNotes = defineAsyncComponent(() =>
  import("@/components/cases/AdditionalNotes")
);
const BillingInformation = defineAsyncComponent(() =>
  import("@/components/cases/BillingInformation")
);
export default {
  components: {
    PatientInformation,
    CaseInformation,
    Medication,
    TestAttachments,
    TestReport,
    BillingNotes,
    CPTCodes,
    BillingCategory,
    AuditLogs,
    AdditionalNotes,
    BillingInformation
  },
  mixins: [UserPermissionsHelper, AppHelper],
  data() {
    return {
      scrollPosition: null,
      loading: false,
      caseId: "",
      AuditLogsPopup: false,
      orderId: "",
      description: "",
    };
  },
  computed: {
    ...mapGetters("cases", [
      "getCaseInformation",
      "getShowMedication",
      "getUpdateCaseStatus",
      "getPreviewCaseData",
    ]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserAllowedLabs",
      "getUserPrimaryLabId",
    ]),
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    caseInfo() {
      return this.getCaseInformation
        ? JSON.parse(JSON.stringify(this.getCaseInformation))
        : null;
    },
    hasBloodPanel() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          (this.getCaseInformation.case_types.indexOf("URINALYSIS") > -1 ||
            this.getCaseInformation.case_types.indexOf("TOXICOLOGY") > -1)
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    hasClinicalChemistryCase() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    isCaseCompleted() {
      if (!this.getCaseInformation) {
        return false;
      }
      return this.getCaseInformation.status === "COMPLETE";
    },
    hasBillingType() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.billing_type &&
        [
          "INSURANCE",
          "PATIENT",
          "LABCORP/SENDOUT",
          "LABCORP",
          "SENDOUT",
        ].includes(this.getCaseInformation.billing_type)
      ) {
        return true;
      }
      return false;
    },
    isCaseHavingAdditionalNotes() {
      if (this.getCaseInformation && this.getCaseInformation.physician_notes) {
        return true;
      }
      return false;
    },
    isOrder() {
      if (this.getCaseInformation && this.getCaseInformation.order_id) {
        return true;
      }
      return false;
    },
    patientId() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.patient_info &&
        this.getCaseInformation.patient_info._id
      ) {
        return this.getCaseInformation.patient_info._id;
      }
      return null;
    },
    checkLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && matchedLab.lab_code == "DLW-TX") {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  async mounted() {
    this.caseId = this.$route.params.case_id;
    await this.fetchCaseInformation();
    // Add Class to body on scroll
    window.addEventListener("scroll", this.onScroll);
  },
  async unmounted() {
    // Remove Class to body on scroll
    document.body.classList.remove("fixedNavbarOnComponent");
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    isInternalOrderEditDisabled(caseDetails) {
      return this.isLabAssistantUser && !!(caseDetails && caseDetails.is_internal_order);
    },
    viewCaseAudit() {
      this.AuditLogsPopup = true;
    },
    async caseDataIntial() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.amendement_details
      ) {
        this.description = `Report Revision Notes: ${this.getCaseInformation.amendement_details.amendment_revision_notes}`;
      }
    },
    goToEditForm() {
      this.$router.push({
        name: "Case-Information-Update",
        params: { case_id: this.$route.params.case_id },
        query: this.$route.query,
      });
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      // For example, adding a class 'scrolled' when the user scrolls more than 100px
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    async fetchCaseInformation() {
      try {
        this.loading = true;
        this.show = false;
        await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
        if (this.getCaseInformation && this.getCaseInformation.order_id) {
          this.show = true;
          this.orderId = this.getCaseInformation.order;
        }
        await this.caseDataIntial();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#generate-barcode-button {
  background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%);
  color: white;
  border-radius: 7px;
  padding: 6px 20px;
  border: none;
  font-weight: 600;
}

.editCase {
  button {
    display: flex;
    align-items: center;
    cursor: pointer;
    background: none;
    border: none;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    border: 1px solid #f24a55;
    background: #f24a55;
    border-radius: 4px;
    padding: 0 10px;

    img {
      margin-right: 7px;
      margin-bottom: -3px;
      width: 15px;
    }
  }
}

.requisition-d-grid {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  column-gap: 10px;

  .leftBlock {
    background: #ffffff;
    padding: 8px 10px;
    border-radius: 6.40567px;
    border: 1.2px solid #e7e7f7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

#case-status-button {
  &:hover {
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }
}

.order-status-reason {
  margin-bottom: 5px;

  .bg-white {
    background: #fff;
    padding: 10px;
    border-radius: 6.40567px;
  }

  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    li {
      position: relative;

      &:not(:last-child) {
        p {
          &:after {
            content: ",";
          }

          color: #333;
        }
      }

      .reason-heading {
        text-transform: uppercase;
        color: #333;
        margin-right: 0;
        font-size: 13px;
        color: #f24a55;
      }

      p {
        font-size: 13px;
        font-weight: 500;
        margin: 0;
        line-height: 1.5;
      }

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
.case-status {
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  justify-content: end;
  li {
    button {
      cursor: default;
    }
  }
}
</style>
